package com.netguru.multiplatform.charts.pie

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import com.netguru.multiplatform.charts.*

internal object PieDefaults {
    const val FULL_CIRCLE_DEGREES = 360f
    const val START_ANGLE = 270.0
    const val NUMBER_OF_COLS_IN_LEGEND = 4
    val THICKNESS = Dp.Infinity
    val GAP_SIZE = 0.dp
    val LEGEND_PADDING = 16.dp
    val LEGEND_ICON_SIZE = 12.dp

    val LegendItemLabel: @Composable (PieChartData) -> Unit = {

        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = it.value.round(1)
            )

            Text(
                text = it.name,
                style = MaterialTheme.typography.bodyMedium,
            )
        }
    }
}
